export default __webpack_public_path__ + "static/media/13-JyskeBank.ca9a1036.png";